import React from 'react';
import { motion } from 'framer-motion';
export function FinalCta() {
  return <section className="bg-gradient-to-br from-[#1A2744] to-[#2D3E6B] py-24 px-5 text-center text-white" data-id="element-48">
      <div className="max-w-3xl mx-auto" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-50">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-5" data-id="element-51">
            Tu hijo te necesita.
            <br data-id="element-52" />
            <span className="text-[#F4A535]" data-id="element-53">Presente. No perfecto.</span>
          </h2>

          <p className="text-lg text-[#B8C8E8] max-w-2xl mx-auto mb-10" data-id="element-54">
            La adolescencia termina. El vínculo que construyas durante estos
            años queda para siempre. Empieza hoy. Con esta guía. Con esta
            conversación.
          </p>

          <p className="text-base text-[#8AA0C0] italic max-w-lg mx-auto mt-10 leading-relaxed" data-id="element-55">
            "El secreto de la crianza es este: no se trata de que tu hijo sea
            perfecto. Se trata de que se sienta amado exactamente como es."
          </p>
        </motion.div>
      </div>
    </section>;
}